import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';

import Slide from '@material-ui/core/Slide';
import { makeStyles } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide ref={ref} direction="up" {...props} />;
});

const useStyles = makeStyles((theme) => ({
  container: {
    backdropFilter: 'blur(5px)'
  },
  header: {
    textAlign: 'left',
    fontSize: 42,
    color: '#132533'
  },
  paper: {
    padding: 30,
    minWidth: 700
  },
  textField: {
    marginTop: '1.5rem',
    width: '100%'
  },
  date: {
    marginRight: theme.spacing(1),
    width: 200
  },
  buttonDiv: {
    marginTop: 15,
    display: 'flex',

    justifyContent: 'flex-end'
  },

  send: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderRadius: 0,
    marginRight: 25,
    minWidth: '110px'
  }
}));

const MeetingRequestModal = ({ open, onClose }) => {
  const [comments, setComments] = useState('');
  const classes = useStyles();
  return ( 
    <div>
      <Dialog
        classes={{ paper: classes.paper, container: classes.container }}
        keepMounted
        maxWidth={false}
        onClose={onClose}
        open={open}
        TransitionComponent={Transition}>
        <DialogContent>
          <TextField
            className={classes.date}
            defaultValue="2020-10-01"
            id="date"
            InputLabelProps={{
              shrink: true
            }}
            label="Date"
            type="date"
          />
          <FormControl className={classes.textField} variant="outlined">
            <OutlinedInput
              id="outlined-adornment-valuation"
              inputProps={{
                'aria-label': 'comments'
              }}
              labelWidth={0}
              multiline
              onChange={(e) => setComments(e.target.value)}
              placeholder="Meeting subject..."
              rows={4}
              rowsMax={4}
              value={comments}
            />
          </FormControl>
        </DialogContent>
        <div className={classes.buttonDiv}>
          <div>
            <Button
              className={classes.send}
              color="primary"
              onClick={onClose}
              variant="contained">
              make request
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default MeetingRequestModal;
